
<div>
  <div class="info-section">
    <p class="info-text">
      This report generates an archive containing account and custodian information for billing purposes.
      The report will include all non-archived accounts for your firm.
    </p>
  </div>

  <div class="button-group">
    <button 
      type="button" 
      class="btn btn-primary action-button" 
      @click="generateReport"
      :disabled="isGenerating"
    >
      <i class="fas fa-download mr-2"></i>
      {{ isGenerating ? 'Generating...' : 'Download Report' }}
    </button>
  </div>
</div>
